export function initProcessProgress() {
  const section = document.querySelector(".process");
  if (!section) return;

  const stepsWrap = section.querySelector(".process__steps");
  const steps = Array.from(section.querySelectorAll(".process__step"));
  const fill = section.querySelector(".process__progress-fill");

  if (!stepsWrap || !steps.length || !fill) return;

  const measure = () => updateProcessConnectors(section);

  // Measure now + after layout settles (fonts/paint)
  measure();
  requestAnimationFrame(() => requestAnimationFrame(measure));
  window.addEventListener("resize", measure);
  window.addEventListener("load", measure);
  setTimeout(measure, 250);

  const seen = new Set();
  let lastMaxSeen = -1;
  let rafPending = false;

  const io = new IntersectionObserver(
    (entries) => {
      let changed = false;

      for (const entry of entries) {
        const i = Number(entry.target.dataset.stepIndex);
        if (!Number.isFinite(i)) continue;

        if (entry.isIntersecting && !seen.has(i)) {
          seen.add(i);
          changed = true;
        }
      }

      if (!changed) return;

      const maxSeen = Math.max(...seen);
      if (maxSeen === lastMaxSeen) return;
      lastMaxSeen = maxSeen;

      // IMPORTANT: measure BEFORE applying is-active so connector animates once
      measure();

      if (rafPending) return;
      rafPending = true;

      requestAnimationFrame(() => {
        rafPending = false;

        steps.forEach((el, i) => el.classList.toggle("is-active", i <= maxSeen));

        const progress = Math.max(0, Math.min(1, (maxSeen + 1) / steps.length));
        fill.style.transform = `scaleY(${progress})`;
      });
    },
    { threshold: 0.35, rootMargin: "0px 0px -30% 0px" },
  );

  steps.forEach((step, i) => {
    step.dataset.stepIndex = String(i);
    io.observe(step);
  });
}

function updateProcessConnectors(section) {
  const stepsWrap = section.querySelector(".process__steps");
  const steps = Array.from(section.querySelectorAll(".process__step"));
  if (!stepsWrap || !steps.length) return;

  const isMobile = window.matchMedia("(max-width: 680px)").matches;
  const isTablet = window.matchMedia("(max-width: 1024px)").matches;

  // MUST match CSS rail x positions exactly
  const railX = isMobile ? 18 : isTablet ? 100 : 140;

  steps.forEach((step) => {
    const body = step.querySelector(".process__body");
    if (!body) return;

    const stepX = step.offsetLeft; // relative to stepsWrap
    const bodyX = body.offsetLeft; // relative to step
    const cardLeftX = stepX + bodyX;

    const width = Math.max(0, cardLeftX - railX);
    step.style.setProperty("--connector-px", `${width}px`);
  });
}
